/**
 * Interrupteur (role="switch") : un reglage actif ou non, applique des le
 * basculement. Pour un choix a valider plus tard dans un formulaire, preferer
 * CaseACocher.
 */
export function Interrupteur({
  actif,
  onChange,
  libelle,
  desactive = false,
  decritPar,
}: {
  actif: boolean;
  onChange: (actif: boolean) => void;
  /** Nom accessible : l'interrupteur n'a pas de texte visible. */
  libelle: string;
  desactive?: boolean;
  decritPar?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={actif}
      aria-label={libelle}
      aria-describedby={decritPar}
      disabled={desactive}
      onClick={() => onChange(!actif)}
      className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
        // neutre-500 (pas neutre-400) : contraste d'au moins 3:1 sur la surface a l'etat eteint.
        actif ? 'bg-accent-600' : 'bg-neutre-500'
      }`}
    >
      <span
        aria-hidden="true"
        className={`inline-block h-4 w-4 rounded-full bg-surface shadow-pose transition-transform ${
          actif ? 'translate-x-4.5' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
}
